import { render, staticRenderFns } from "./ModalAddAvenantv2.vue?vue&type=template&id=58fcbe0f&"
import script from "./ModalAddAvenantv2.vue?vue&type=script&lang=js&"
export * from "./ModalAddAvenantv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports